
import { computed, defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    components: { Cheap },
    setup(props) {
        const getClass = computed(() => {
            let className = ''

            if (['Подтверждено', 'В пределах нормы'].includes(props.row.status)) {
                className += 'green'
            } else {
                className += 'red'
            }

            return className
        })
        return { getClass }
    },
})
